import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col bg-cream-100" data-id="element-105">
      <Header data-id="element-106" />
      <main className="flex-grow" data-id="element-107">{children}</main>
      <Footer data-id="element-108" />
    </div>;
}